/*
 * File: /src/router/routes/airbnbtemplates.js
 * Created Date: Saturday November 14th 2020
 * Author: Nicolas Wegener, Roy Collins
 * -----
 * Last Modified: Saturday, 14th November 2020 8:55:51 pm
 * Modified By: Nicolas Wegener (wegenern@gmail.com)
 * -----
 * Copyright (c) 2020 AdBase, Inc.
 */

const AirbnbTemplateList = () =>
  import(/* webpackChunkName: "AirbnbTemplateList" */ 'src/components/Dashboard/Views/AirbnbTemplates/AirbnbTemplateList.vue');

const AirbnbTemplateEdit = () =>
  import(/* webpackChunkName: "AirbnbTemplateEdit" */ 'src/components/Dashboard/Views/AirbnbTemplates/AirbnbTemplateEdit.vue');
export const airbnbTemplateRoutes = [
  {
    path: 'airbnb-templates/add/',
    name: 'Add Whatapp Template',
    component: AirbnbTemplateEdit,
  },

  {
    path: 'airbnb-templates/edit/:id',
    name: 'Edit Airbnb Template',
    component: AirbnbTemplateEdit,
  },
  {
    path: 'airbnb-templates/list/',
    name: 'List Airbnb Templates',
    component: AirbnbTemplateList
  }
];
